import { join, initial, split } from 'lodash';

export const useExportCanvasAnnotations = ({
  image,
  imageWithSize,
  fabricOverlay,
}) => {
  function mergeImageAndSVGFromURL(imageUrl, svgString, callback) {
    const img = new Image();
    img.crossOrigin = 'Anonymous';

    img.onload = () => {
      const canvas = document.createElement('canvas');
      canvas.width = img.width;
      canvas.height = img.height;
      const ctx = canvas.getContext('2d');

      ctx.drawImage(img, 0, 0);

      const svgBlob = new Blob([svgString], {
        type: 'image/svg+xml;charset=utf-8',
      });
      const svgUrl = URL.createObjectURL(svgBlob);
      const svgImg = new Image();
      svgImg.crossOrigin = 'Anonymous';
      svgImg.onload = () => {
        ctx.drawImage(svgImg, 0, 0, canvas.width, canvas.height);
        URL.revokeObjectURL(svgUrl);

        const mergedDataUrl = canvas.toDataURL('image/png');
        callback(mergedDataUrl);
      };
      svgImg.src = svgUrl;
    };
    img.src = imageUrl;
  }

  const exportWithCanvasAnnotations = () => {
    const canvas = fabricOverlay.fabricCanvas();

    const originalViewport = canvas.viewportTransform;
    const originalZoom = canvas.getZoom();

    // RESET
    canvas.setViewportTransform([1, 0, 0, 1, 0, 0]);
    canvas.setZoom(1);
    canvas.renderAll();

    const svg = canvas.toSVG({
      suppressPreamble: true,
      width: imageWithSize.width,
      height: imageWithSize.height,
      viewBox: `0 0 ${imageWithSize.width} ${imageWithSize.height}`,
    });

    // RESTORE
    canvas.setViewportTransform(originalViewport);
    canvas.setZoom(originalZoom);
    canvas.renderAll();

    mergeImageAndSVGFromURL(image.download_url, svg, (mergedDataUrl) => {
      const link = document.createElement('a');
      link.href = mergedDataUrl;
      link.download =
        join(initial(split(image.title, '.')), '.') + '_annotated.png';
      link.click();
    });
  };

  return { exportWithCanvasAnnotations };
};
